jQuery(document).ready(function($) {
  //Prouct Slider
//   $('.card-slider').slick({
//       infinite: true,
//       slidesToShow: 4,
//       slidesToScroll: 1,
//       autoplay: true,
//       autoplaySpeed: 2000,
//       arrows:true,
//       prevArrow: `
//         <button type="button" class="slick-prev">
//           <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
//             <g> 
//               <rect width="48" height="48" rx="24" transform="matrix(-1 0 0 1 48 0)" fill="white"/>
//               <mask id="mask0_2091_1094" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
//                 <rect width="24" height="24" transform="matrix(-1 0 0 1 36 12)" fill="#D9D9D9"/>
//               </mask>
//               <g mask="url(#mask0_2091_1094)">
//                 <path d="M27.9846 33.6538L29.4038 32.2345L21.1693 24L29.4038 15.7655L27.9846 14.3463L18.3308 24L27.9846 33.6538Z" fill="#1C1B1F"/>
//               </g>
//             </g>
//           </svg>
//         </button>`,
//       nextArrow: `
//         <button type="button" class="slick-next">
//           <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
//             <rect width="48" height="48" rx="24" fill="white"/>
//             <mask id="mask0_2091_1099" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24">
//               <rect x="12" y="12" width="24" height="24" fill="#D9D9D9"/>
//             </mask>
//             <g mask="url(#mask0_2091_1099)">
//               <path d="M20.0154 33.6538L18.5962 32.2345L26.8307 24L18.5962 15.7655L20.0154 14.3463L29.6692 24L20.0154 33.6538Z" fill="#1C1B1F"/>
//             </g>
//           </svg>
//         </button>`,
//       responsive: [
//           {
//             breakpoint: 992,
//             settings: {
//               slidesToShow: 1,
//               centerMode: true,
//               arrows: false
//             }
//           }
//       ]
//     });

  //FAQ Functionality
  // $('.faq-item').on('click', function() {
  //     $('.faq-item').addClass('faq-item-closed').removeClass('faq-item-open');
  //     $('.faq-item .bi').removeClass('bi-chevron-up').addClass('bi-chevron-down');
  //     $('.faq-item div').removeClass('mb-3').addClass('mb-0');
      
  //     $(this).removeClass('faq-item-closed').addClass('faq-item-open');
  //     $(this).find('.bi').removeClass('bi-chevron-down').addClass('bi-chevron-up');
  //     $(this).find('div').removeClass('mb-0').addClass('mb-3');
  // });
  // $('.faq-item').on('click', function () {
  //   $('.faq-item')
  //     .addClass('faq-item-closed')
  //     .removeClass('faq-item-open bg-light'); // remove bg-light from all
  
  //   $('.faq-item .bi')
  //     .removeClass('bi-chevron-up')
  //     .addClass('bi-chevron-down');
  
  //   $('.faq-item div')
  //     .removeClass('mb-3')
  //     .addClass('mb-0');
  
  //   $(this)
  //     .removeClass('faq-item-closed')
  //     .addClass('faq-item-open bg-light'); // add bg-light to active
  
  //   $(this).find('.bi')
  //     .removeClass('bi-chevron-down')
  //     .addClass('bi-chevron-up');
  
  //   $(this).find('div')
  //     .removeClass('mb-0')
  //     .addClass('mb-3');
  // });

  //Filter Functionality Service
  $('.service-filter-button-wrapper .btn-tab').on('click', function () {
    const filterId = $(this).attr('id');

    $('.service-filter-button-wrapper .btn-tab').removeClass('active');
    $(this).addClass('active');

    if (filterId === 'filterAll') {
        $('.service-card-wrapper').show();
    } else {
        $('.service-card-wrapper').hide();
        $(`.service-card-wrapper[data-filter-id="${filterId}"]`).show();
    }
  });

  //Filter Functionality Home
  $(document).ready(function () {
      // Hide all location-card-wrapper except for filterAll on page load
      $('.location-slider-wrapper .location-card-wrapper').addClass('d-none');
      $('.location-slider-wrapper .location-card-wrapper[data-filter-id="filterAll"]').removeClass('d-none');
  
      // Add click event for the filter buttons
      $('.location-slider-wrapper .btn-tab').on('click', function () {
          const filterId = $(this).attr('id');
  
          $('.location-slider-wrapper .btn-tab').removeClass('active');
          $(this).addClass('active');
  
          // Hide all location-card-wrapper and show the relevant one
          $('.location-slider-wrapper .location-card-wrapper').addClass('d-none');
          if (filterId === 'filterAll') {
              $('.location-slider-wrapper .location-card-wrapper[data-filter-id="filterAll"]').removeClass('d-none');
          } else {
              $(`.location-slider-wrapper .location-card-wrapper[data-filter-id="${filterId}"]`).removeClass('d-none');
          }
      });
  });
  
  //Products Details Tab Functionality
  $('.btn-tab').on('click', function () {
    $('.btn-tab').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').removeClass('active');
    const target = $(this).data('target');
    $(`#${target}`).addClass('active');
});

  //Region Modal Button Active #regionModal a.btn.btn-primary
  $('.region-location a.btn.btn-primary').on('click', function () {
    $('.region-location a.btn.btn-primary').removeClass('active');
    $(this).addClass('active');
  });
  $('.region-language a.btn.btn-primary').on('click', function () {
    $('.region-language a.btn.btn-primary').removeClass('active');
    $(this).addClass('active');
  });
  $('.region-currency a.btn.btn-primary').on('click', function () {
    $('.region-currency a.btn.btn-primary').removeClass('active');
    $(this).addClass('active');
  });

  //Mobile Navigation Menu
  $('#menuNavShow').on('click', function () {
      $(this).hide();
      $('#menuNavHide').show();
      $('#mobileNav').show();
      $('header').addClass('active');
  });

  $('#menuNavHide').on('click', function () {
      $(this).hide();
      $('#menuNavShow').show();
      $('#mobileNav').hide();
      $('header').removeClass('active');
  });
  // Mobile Footer Expand Collapse Functionality
  // if ($(window).width() <= 991) { // Apply only on mobile screens
  //     $(".col-5-custom p").each(function () {
  //         // Append the initial '+' SVG icon to each <p>
  //         $(this).append(`
  //             <span class="toggle-icon">
  //                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  //                     <mask id="mask0_2374_4980" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  //                         <rect width="24" height="24" fill="#D9D9D9"/>
  //                     </mask>
  //                     <g mask="url(#mask0_2374_4980)">
  //                         <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill="#B8946A"/>
  //                     </g>
  //                 </svg>
  //             </span>
  //         `);
  //     });

  //     $(".col-5-custom p").on("click", function () {
  //         let content = $(this).next("hr").next("ul");
  //         let icon = $(this).find(".toggle-icon");

  //         content.slideToggle(300, function () { 
  //             if ($(this).is(":visible")) {
  //                 icon.html(`
  //                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  //                         <mask id="mask0_2374_4993" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  //                             <rect width="24" height="24" fill="#D9D9D9"/>
  //                         </mask>
  //                         <g mask="url(#mask0_2374_4993)">
  //                             <path d="M5 13V11H19V13H5Z" fill="#B8946A"/>
  //                         </g>
  //                     </svg>
  //                 `);
  //             } else {
  //                 icon.html(`
  //                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  //                         <mask id="mask0_2374_4980" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
  //                             <rect width="24" height="24" fill="#D9D9D9"/>
  //                         </mask>
  //                         <g mask="url(#mask0_2374_4980)">
  //                             <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill="#B8946A"/>
  //                         </g>
  //                     </svg>
  //                 `);
  //             }
  //         });
  //     });
  // }
});
// $(document).ready(function () {
//   $(".client-logo-slider").slick({
//     infinite: true,
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     arrows: false
//   });
// });

// jS for Service dropdown
// document.querySelector('.services-toggle').addEventListener('click', function (e) {
//   e.preventDefault();
//   this.classList.toggle('active');
//   document.querySelector('.services-mega-dropdown').classList.toggle('d-none');
// });
document.addEventListener('DOMContentLoaded', function () {
    // Handle toggle clicks
    document.querySelectorAll('.services-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
  
        const parentLi = this.closest('li');
        const dropdown = parentLi.querySelector('.services-mega-dropdown');
        const icon = this.querySelector('i'); // find the <i> icon inside the link
  
        const isOpen = !dropdown.classList.contains('d-none');
  
        // Close all dropdowns
        document.querySelectorAll('.services-mega-dropdown').forEach(el => el.classList.add('d-none'));
        document.querySelectorAll('.services-toggle').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.services-toggle i').forEach(el => el.classList.remove('rotate-180'));
  
        // Toggle current only if it was not already open
        if (!isOpen) {
          this.classList.add('active');
          dropdown.classList.remove('d-none');
          if (icon) {
            icon.classList.add('rotate-180');
          }
        }
      });
    });
  
    // Outside click closes dropdown
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-item')) {
        document.querySelectorAll('.services-mega-dropdown').forEach(el => el.classList.add('d-none'));
        document.querySelectorAll('.services-toggle').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.services-toggle i').forEach(el => el.classList.remove('rotate-180'));
      }
    });
  });

  
  document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".faq-item");
  
    faqItems.forEach((item) => {
      const answer = item.querySelector(".faq-answer");
  
      if (item.classList.contains("faq-item-open")) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        console.log("Initial open:", answer.scrollHeight + "px");
      }
  
      item.addEventListener("click", function () {
        const isOpen = item.classList.contains("faq-item-open");
  
        if (isOpen) {
          console.log("Closing item...");
  
          item.classList.remove("faq-item-open", "bg-light");
          item.classList.add("faq-item-closed");
  
          item.querySelector("i").classList.remove("bi-chevron-up");
          item.querySelector("i").classList.add("bi-chevron-down");
  
          const header = item.querySelector(".d-flex");
          header.classList.remove("mb-3");
          header.classList.add("mb-0");
  
          // Debug: show current height
          console.log("Current scrollHeight before close:", answer.scrollHeight);
  
          // Step 1: Set current height
          answer.style.maxHeight = answer.scrollHeight + "px";
  
          // Step 2: Force reflow
          answer.offsetHeight; // triggers reflow
  
          // Step 3: Set to 0 for transition
          answer.style.maxHeight = "0px";
  
          console.log("Set max-height to 0px (closing).");
  
          return;
        }
  
        // Close all other items
        faqItems.forEach((el) => {
          if (el !== item) {
            const elAnswer = el.querySelector(".faq-answer");
  
            el.classList.remove("faq-item-open", "bg-light");
            el.classList.add("faq-item-closed");
  
            el.querySelector("i").classList.remove("bi-chevron-up");
            el.querySelector("i").classList.add("bi-chevron-down");
  
            const elHeader = el.querySelector(".d-flex");
            elHeader.classList.remove("mb-3");
            elHeader.classList.add("mb-0");
  
            elAnswer.style.maxHeight = elAnswer.scrollHeight + "px";
            elAnswer.offsetHeight; // trigger reflow
            elAnswer.style.maxHeight = "0px";
          }
        });
  
        // Open current item
        item.classList.remove("faq-item-closed");
        item.classList.add("faq-item-open", "bg-light");
  
        item.querySelector("i").classList.remove("bi-chevron-down");
        item.querySelector("i").classList.add("bi-chevron-up");
  
        const header = item.querySelector(".d-flex");
        header.classList.remove("mb-0");
        header.classList.add("mb-3");
  
        answer.style.maxHeight = answer.scrollHeight + "px";
        console.log("Opening item, setting max-height to:", answer.scrollHeight + "px");
      });
    });
  });